import { createSelector } from "reselect";
import { IRootReducer } from "../../Models/IRootReducer";
import { IUser } from "../../Models/IUser";
import { IUserShareSettings } from "../../Models/IUserShareSettings";

export const userSelector = createSelector(
    (state: IRootReducer) => state.user?.user,
    (user: IUser) => user
);

export const userShareSettingsSelector = createSelector(
    (state: IRootReducer) => state.user?.shareSettings,
    (shareSettings: IUserShareSettings) => shareSettings
);

export const loadingAllUsersSelector = createSelector(
    (state: IRootReducer) => state.user?.loadingAllUsers,
    (loading: boolean) => loading
);

export const allUsersSelector = createSelector(
    (state: IRootReducer) => state.user?.allUsers,
    (all: IUser[]) => all
);

export const showActiveUsersSelector = createSelector(
    (state: IRootReducer) => state.user?.showActiveUsers,
    (showActiveUsers: boolean) => showActiveUsers
);
